export default __webpack_public_path__ + "static/media/TL.265f5416.svg";